import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventApi } from '@fullcalendar/core';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { UiStoreHelperService } from '@radioking/shared/common-services';
import { Observable, Subscription } from 'rxjs';
import {
  PlanningDeleteSlotFailure,
  PlanningDeleteSlotRequest,
  PlanningDeleteSlotSuccess,
} from '../../states/planning.actions';

@Component({
  selector: 'rk-planning-slot-deletion',
  templateUrl: './planning-slot-deletion.component.html',
  styleUrls: ['./planning-slot-deletion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanningSlotDeletionComponent implements OnInit, OnDestroy {
  deleteAll = false;

  get slotRepeat(): boolean {
    return this.event.extendedProps.repeat;
  }

  /**
   * Whether dialog is in a loading state or not (when saving)
   */
  isLoading$: Observable<boolean>;

  subscription = new Subscription();

  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly uiStore: UiStoreHelperService,
    private readonly dialogRef: MatDialogRef<PlanningSlotDeletionComponent>,
    @Inject(MAT_DIALOG_DATA) public event: EventApi,
  ) {}

  ngOnInit(): void {
    this.uiStore.getLoadingState(PlanningDeleteSlotRequest, [
      PlanningDeleteSlotFailure,
      PlanningDeleteSlotSuccess,
    ]);

    // Deletion succeed: close this dialog
    this.subscription.add(
      this.actions$.pipe(ofActionDispatched(PlanningDeleteSlotSuccess)).subscribe(() => {
        this.closeSelf();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Deletion submitted
   */
  onSubmit(): void {
    const occurrenceId = Number.parseInt(this.event.id, 10);
    this.store.dispatch(
      new PlanningDeleteSlotRequest(
        this.deleteAll,
        this.event.extendedProps.id,
        occurrenceId,
      ),
    );
  }

  /**
   * Close self (closing dialog)
   */
  closeSelf(): void {
    this.dialogRef.close();
  }
}
